import { render, staticRenderFns } from "./TopicDetail.vue?vue&type=template&id=aead0262&scoped=true&"
import script from "./TopicDetail.vue?vue&type=script&lang=js&"
export * from "./TopicDetail.vue?vue&type=script&lang=js&"
import style0 from "./TopicDetail.vue?vue&type=style&index=0&id=aead0262&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aead0262",
  null
  
)

export default component.exports